export const state = {
    appName: "pgslot245 - สล็อตอันดับ 1 ในประเทศไทย",
    user: null,
    error: null,
    loading: false,
    access_token: null,
    lineId: "@pgslot245"
}